import { render } from "./CombinedPieChartAndTable.vue?vue&type=template&id=425191ca&scoped=true"
import script from "./CombinedPieChartAndTable.vue?vue&type=script&lang=js"
export * from "./CombinedPieChartAndTable.vue?vue&type=script&lang=js"

import "./CombinedPieChartAndTable.vue?vue&type=style&index=0&id=425191ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425191ca"]])

export default __exports__